<template>
  <div id="new-event">
    <PageTitle v-if="id==''" title="Evenement toevoegen" description="Momenteel worden gekoppelde bestanden nog niet in de app verwerkt."></PageTitle>
    <PageTitle v-if="id!=''"
      title="Evenement aanpassen"
      description="Als er een bestand is gekoppeld is hieronder de bestandsnaam zichtbaar. Wanneer je een nieuw bestand kiest wordt de oude verwijderd."
    ></PageTitle>

    <form @submit.prevent>
      <div class="form-group float-right">
        <button @click="cancel" class="btn btn-light mr-2">Annuleren</button>
        <button @click="saveItem(false)" class="btn btn-warning mr-2">Opslaan als concept</button>
        <button @click="saveItem(true)" class="btn btn-success">Opslaan en publiceren</button>
      </div>
      <Storage path="events/" v-on:setUrl="setUrl" v-on:setFilename="setFilename" ></Storage>
      <div class="form-group">
        <label for="title">Titel</label>
        <input type="text" class="form-control" placeholder="Titel" v-model="title" />
      </div>
      <div class="form-group">
        <label for="section">Beschrijving</label>
        <textarea class="form-control" id="section" v-model="content" rows="5"></textarea>
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="section">Start datum</label>
          <input type="date" class="form-control" v-model="startdate" @change="validateEnddate"  />
        </div>
        <div class="col">
          <label for="section">Start tijd</label>
          <input type="time" class="form-control" v-model="starttime"/>
        </div>
        <div class="col">
          <label for="section">Eind datum</label>
          <input type="date" class="form-control" v-model="enddate" @change="validateEnddate" />
        </div>
        <div class="col">
          <label for="section">Eind tijd</label>
          <input type="time" class="form-control" v-model="endtime" />
        </div>
      </div>

      <div class="form-group">
        <label for="section">Type event</label>
        <input type="text" class="form-control" placeholder="bijeenkomst" v-model="type" />
      </div>
      <div class="form-group">
        <label for="section">Locatie</label>
        <input type="text" class="form-control" placeholder="-" v-model="location" />
      </div>
      <Selectoptions v-on:setOptions="setOptions"></Selectoptions>
    </form>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import PageTitle from "@/components/PageTitle.vue";
import Storage from "@/components/Storage.vue";
import Selectoptions from "@/components/Selectoptions.vue";
var firestorage = fb.firestorage;

export default {
  name: "new-event",
  components: {
    PageTitle,
    Storage,
    Selectoptions
  },
  data() {
    return {
      id: "",
      title: "",
      content: "",
      type: "event",
      location: "",
      startdate: this.getToday(),
      enddate: this.getToday(),
      starttime: "09:00",
      endtime: "17:00",
      checkedEstablishments: [],
      checkedPositions: [],
      downloadURL: "",
      fileName: "",    
    };
  },
  methods: {
      getToday(){
        var d = new Date()
        return d.getFullYear() + "-" + (d.getMonth()+1 < 10 ? "0" : "") + (d.getMonth()+1) + "-" + (d.getDate() <10 ? "0" : "") + d.getDate()
        //console.log(ret)
        //return ret
      },
      validateEnddate(){
          // end date must be after start date
          console.log("check end date")
          if (this.enddate < this.startdate) this.enddate = this.startdate
          // TODO december -> jauari dan werkt dit natuurlijk niet
      },
    setOptions(data) {
      this.checkedPositions = data.checkedPositions;
      this.checkedEstablishments = data.checkedEstablishments;
    },
    setUrl(url) {
      this.downloadURL = url;
    },
    setFilename(fn) {
      this.fileName = fn;
    },
    /*
    for now you can only add 1 image. The db structure is prepared to add more. TODO
    */
    saveItem(live) {
      var now = new Date();
      var sd = this.startdate + "T" + (this.starttime == '' ? "00:00" : this.starttime);
      var ed = this.enddate + "T" + (this.endtime == '' ? "00:00" : this.endtime);
      var months = this.getMonthArray()
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("calendar")
        .add({
          can_comment: false,
          date_created: now.toISOString(),
          title: this.title,
          content: this.content,
          location: this.location,
          date_end: ed,
          date_start: sd,
          status: live ? "live" : "concept",
          type: this.type == "" ? "gebeurtenis" : this.type,
          month: months,
          files: this.downloadURL == '' ? null : [{ url: this.downloadURL, filename: this.fileName }],
          establishments:
            this.checkedEstablishments.length > 0
              ? this.checkedEstablishments
              : null,
          positions:
            this.checkedPositions.length > 0 ? this.checkedPositions : null
        })
        .then(docRef => {
          console.log(docRef.id);
          if (live) this.addNotification(docRef.id);
          this.$router.push("/calendar");
        })
        .catch(error => console.log(error));
    },
    addNotification(docId){
        /*
        adds a notification to fbase when published
        this will trigger a firebase function to send a push notification to effected users
        */


      /*
        adds a notification to fbase when published
        this will trigger a firebase function to send a push notification to effected users
        */

      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "event",
              refid: docId,
              date: now,
              created_by: this.$cookies.get("user"),
              title: this.title,
              message:
                "Er is een nieuw event in de agenda geplaatst. Je vindt dit in de kalender.",
              establishments:
                this.checkedEstablishments.length > 0
                  ? this.checkedEstablishments
                  : null,
              positions:
                this.checkedPositions.length > 0 ? this.checkedPositions : null,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });

    },
    cancel() {
      if (this.downloadURL != "") {
        firestorage
          .ref("events/" + this.$cookies.get("company") + "/" + this.fileName)
          .delete()
          .then(() => {
            this.$router.go(-1);
          })
          .catch(error => {
            console.error(`file delete error occured: ${error}`);
          });
      } else {
        this.$router.go(-1);
      }
    },
  getMonthArray(){
      /*
      this method is introduced only because it is not possible to query firebase with more then 1 where clause
      goal is to prevent the app to load all events, so it will only load events in the current month
      offcourse this also loads events form other years, so it is just a temporary crappy solution
      In the Flutter code see database_service.dart method  Stream<List<CalendarEvent>> get calendarEvents
      */
      var temp = this.startdate.split("-");
      var month1 = parseInt(temp[1])
      temp = this.enddate.split("-")
      var month2 = parseInt(temp[1])
      var months = [ month1 ]
      while (month1 != month2){
        month1++;
        if (month1 > 12) month1 = 1        
        months.push(month1)
      }
      console.log(months)
      return months
  }
  },

  beforeRouteEnter(to, from, next) {
        if (to.params.id && to.params.id != "new") {
        //  files: this.downloadURL == '' ? null : [{ url: this.downloadURL, filename: this.fileName }],       
      fb.companiesCollection
        .doc(window.$cookies.get("company"))
        .collection("calendar")
        .doc(to.params.id)
        .get()
        .then(doc => {
          next(vm => {
            vm.id = doc.id;
            vm.title = doc.data().title;
            vm.content = doc.data().content;
            vm.location = doc.data().location;
            vm.date_start = doc.data().date_start;
            vm.date_end = doc.data().date_end;
            vm.type = doc.data().type ?? "event";
            vm.months = doc.data().months;

            if (doc.data().establishments != null)
              vm.checkedEstablishments = doc.data().establishments;
            if (doc.data().positions != null)
              vm.checkedPositions = doc.data().positions;
            vm.downloadURL = doc.data().files[0].url ?? "";
            vm.fileName = doc.data().files[0].filename ?? "";
          });
        });
    } else {
      next();
    }
  }
};
</script>